<template>
  <div>
    <modal-row label="Reference">
      <b-input size="sm" v-model="edit.item_ref" :readonly="!!ref" class="bg-white"/>
    </modal-row>
    <modal-row label="Send Via">
      <b-select :options="sources" v-model="source"/>
    </modal-row>
    <modal-row label="To">
      <b-select v-model="edit.account_address" size="sm" :options="$store.state.settings.defaults.users.map(u => ({text: `${u.name} (${u.userid})`, value: u.id}))" v-if="source && source.source === 'y'"/>

      <!-- the record's own contacts, when it has any: which person at a
           vendor a bid goes to, or which of a customer's addresses an order
           update goes to, is a choice rather than a property of the record,
           so it is offered instead of prefilled and locked. Email only - an
           eBay send addresses a buyer user id, which is not pickable. -->
      <b-select v-else-if="source && source.source === 's' && recipients.length && !other" size="sm"
                :value="edit.account_address" :options="recipientOptions"
                @change="pickRecipient"/>

      <b-input v-else size="sm" v-model="edit.account_address"
               :readonly="!!ref && !other && !recipientsTried" class="bg-white"/>
    </modal-row>
    <modal-row label="" v-if="recipientDnc && source && source.source === 's'">
      <div class="small text-danger">
        This address is on the do-not-contact list.
      </div>
    </modal-row>
    <modal-row label="Subject">
      <b-input v-model="edit.subject" size="sm"/>
    </modal-row>
  </div>
</template>

<script>
// sentinel for the "type it yourself" row in the recipient select - an address
// can never be this, so it cannot collide with a real choice
const OTHER = '\u0000other'

// where the short name is not simply capitalised
const KINDS = {po: 'PO'}

export default {
  name: "message-compose-direct",
  props: {
    value: Object,
    reference: Object
  },
  data() {
    return {
      edit: this.value,
      ref_vals: {},
      ref: null,
      ref_url: null,
      ref_type: null,
      source: null,
      addresses: {},
      sources: [],
      // every address the referenced record can be written to, main first
      recipients: [],
      recipientsTried: false,
      other: false
    }
  },
  watch: {
    value(v) {
      this.edit = v
    },
    edit(v) {
      this.$emit('input', v)
    },
    source(v) {
      this.changeSource(v)
    }
  },
  computed: {
    auction_list() {
      return this.auctions ? this.auctions.map(f => {

      }) : []
    },

    recipientOptions() {
      return [
        ...this.recipients.map(r => ({
          text: (r.name ? `${r.name} <${r.email}>` : r.email)
              + (r.source === 'Main contact' ? ' — main' : '')
              + (r.do_not_contact ? ' — do not contact' : ''),
          value: r.email
        })),
        {text: 'Other address…', value: OTHER}
      ]
    },

    recipientDnc() {
      const match = this.recipients.find(r => r.email === this.edit.account_address)
      return !!(match && match.do_not_contact)
    }
  },
  async created() {
    if (typeof this.reference === 'object' && Object.keys(this.reference).length == 1) {
      this.ref_type = Object.keys(this.reference)[0]
      if (this.ref_type === 'order') {
        if (this.reference[this.ref_type]) {
          try {
            this.ref_url = this.reference[this.ref_type]
            this.ref = await this.asyncAction(this.ref_url, 'GET')
          } catch {
            this.ref = null
          }
        } else if (this.$store.state.record.type === this.ref_type) {
          this.ref_url = this.$store.state.record.active._links.self_url.href
          this.ref = this.$store.state.record.active
        } else {
          this.ref = null
        }

        if (this.ref) {
          this.refOrder()
          await this.loadRecipients()
        }
      } else if (['lead', 'customer', 'vendor', 'quote', 'bid', 'po'].includes(this.ref_type) && this.reference[this.ref_type]) {
        try {
          this.ref_url = this.reference[this.ref_type]
          this.ref = await this.asyncAction(this.ref_url, 'GET')
        } catch {
          this.ref = null
        }

        if (this.ref) {
          this.refGeneric()
          await this.loadRecipients()
        }
      }
    }

    this.$nextTick(() => {
      this.source = this.sources[0].value
      this.changeSource(this.source)
    })
  },

  mounted() {
    if (!this.reference && this.can('messages.create.internal'))
      this.sources.push({text: 'Internal / Direct Message', value: {source: 'y'}})
    if (this.can('messages.create'))
      this.sources.push({text: 'Email', value: {source: 's'}})
  },

  methods: {
    changeSource(v) {
      this.$set(this.edit, 'account_address', v.address)
      this.$set(this.edit, 'source', v.source)
    },
    refOrder() {
      this.edit.subject = 'Order ' + this.ref.gli
      this.sources[0].value.address = this.ref.email
      if (this.ref.auction_order_map && !!this.ref.auction_order_map.length) {
        this.ref.auction_order_map.forEach((map, idx) => {
          this.sources.unshift({
            text: 'eBay - ' + map.itemno + ' (' + map.eb_OrderID + ')',
            value: {source: 't', address: map.eb_Buyer_UserID}
          })
        })
      }
      this.edit.item_ref = this.ref.gli

    },
    refGeneric() {
      const kind = KINDS[this.ref_type]
          || this.ref_type.charAt(0).toUpperCase() + this.ref_type.slice(1)
      // bill_name covers a quote, which has no name/company of its own;
      // vendor.company covers a bid or a PO, which name a vendor rather than
      // being one
      const label = this.ref.name || this.ref.company || this.ref.bill_name
        || (this.ref.vendor && this.ref.vendor.company)
        || (this.ref.main_email_contact && this.ref.main_email_contact.contact_name) || ''

      this.edit.subject = `${kind} ${this.ref.gli}` + (label ? ' – ' + label : '')
      this.edit.item_ref = this.ref.gli

      const email = this.ref.email
        || (this.ref.main_email_contact && this.ref.main_email_contact.contact)
        || (Array.isArray(this.ref.contacts)
          ? (this.ref.contacts.find(c => c.method === 'E' || c.is_email) || {}).contact
          : null)

      const emailSource = this.sources.find(s => s.value && s.value.source === 's')
      if (emailSource && email)
        emailSource.value.address = email
    },

    /**
     * The addresses this record can be written to.
     *
     * Advisory: a record with no recipients_url, or one that fails to answer,
     * simply leaves the free-text field in place rather than blocking the
     * compose. The first address becomes the default, which is the main
     * contact - the server orders the list.
     */
    async loadRecipients() {
      const link = this.ref._links && this.ref._links.recipients_url

      if (!link)
        return

      try {
        this.recipients = await this.asyncAction(link.href, link.method, {noload: true, quiet: true}) || []
      } catch {
        this.recipients = []
      }

      this.recipientsTried = true

      if (!this.recipients.length)
        return

      const emailSource = this.sources.find(s => s.value && s.value.source === 's')
      if (emailSource)
        emailSource.value.address = this.recipients[0].email

      // created() sets the source after this resolves in the usual case, but
      // not when the fetch is slow - so seed the field either way
      if (!this.edit.account_address)
        this.$set(this.edit, 'account_address', this.recipients[0].email)
    },

    pickRecipient(v) {
      if (v === OTHER) {
        this.other = true
        this.$set(this.edit, 'account_address', '')
        return
      }

      this.$set(this.edit, 'account_address', v)
    },
  }
}
</script>

<style scoped>

</style>